import type { SeoResolver } from '../types';

/**
 * SEO for a selected temple (HRCE). Moved verbatim from SEO.tsx. This is the
 * only resolver that is bilingual — it reads ctx.language to pick the English
 * or Tamil name / district / deity.
 */
export const templeSeoResolver: SeoResolver = (ctx) => {
  const temple = ctx.selections.temple;
  if (!temple) return null;

  const { siteName, layerName, language } = ctx;
  const name = language === 'ta' ? temple.nm.tn : temple.nm.en;
  const district = language === 'ta' ? temple.dist.tn : temple.dist.en;
  const deity = language === 'ta' ? temple.c?.mol?.tn : temple.c?.mol?.en;
  const deityStr = deity ? ` (${language === 'ta' ? 'மூலவர்' : 'Deity'}: ${deity})` : '';

  return {
    title: `${name} | ${layerName} in ${district} | ${siteName}`,
    description: `Explore details for ${name}${deityStr} located in ${district} District, Tamil Nadu. View maps, driving directions, and complete metadata on ${siteName}.`,
    breadcrumbLabel: name
  };
};
